import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FC, useMemo } from "react";
import GenericCrudTable from "@/components/tables/genericCrudTable";
import { MRT_ColumnDef } from "material-react-table";
import { replaceDate } from "@/helper/dateHandling";
import { noteEntityAdapter } from "@/components/subjectOverview/noteEntityAdapter";

interface Props {
  detailedSubject?: any;
}

const SubjectOverviewNotes: FC<Props> = ({ detailedSubject }) => {
  const { t } = useTranslation();
  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: t("id"),
        id: "id",
      },
      {
        accessorKey: "created_on",
        header: t("created_on"),
        id: "created_on",
        filterVariant: "date",
        sortingFn: "datetime",
        Cell: ({ cell }: any) => {
          const value = cell.getValue();
          return (
            <Tooltip
              title={value === null ? "-" : replaceDate(value, true)}
              placement="top-end"
            >
              <span>{value === null ? "-" : replaceDate(value)}</span>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "payload",
        header: t("string"),
        id: "payload",
        enableForCreate: true,
        textarea: true,
        textareaRows: 25,
        size: 400,
        Cell: ({ cell }: any) => {
          let value = cell.getValue();
          if (typeof value === "object") {
            value = Object.entries(value)
              .map(([key, value]) => `${key}: ${value}`)
              .join(", ");
          }
          return <span>{value}</span>;
        },
      },
      {
        accessorKey: "created_by.name",
        header: t("created_by"),
        id: "created_by.name",
        customColumnFilterId: "created_by_name",
        childEntityName: "created_by",
      },
      {
        accessorKey: "entity_id",
        header: "EntityId",
        id: "entity_id",
        enableHiding: false,
      },
      {
        accessorKey: "entity_type",
        header: "EntityType",
        id: "entity_type",
        enableHiding: false,
      },

      {
        accessorKey: "modified_by.name",
        header: t("modified_by"),
        id: "modified_by.name",
        customColumnFilterId: "modified_by_name",
        childEntityName: "modified_by",
      },
      {
        accessorKey: "modified_on",
        header: t("modified_on"),
        id: "modified_on",
        filterVariant: "date",
        sortingFn: "datetime",
        Cell: ({ cell }: any) => {
          const value = cell.getValue();
          return (
            <span>{value === null ? "-" : replaceDate(value)}</span>
          );
        },
      },
    ],
    []
  );
  return (
    <GenericCrudTable
      columns={columns}
      entity="note"
      entityAdapter={noteEntityAdapter}
      customGlobalFilterPosition={"left"}
      customDensity="compact"
      customPageSize={5}
      // showRowActions={false}
      searchId={detailedSubject?.id}
      customModalStyle={{ width: "70vw", minHeight: "40em" }}
      customColumnVisibility={{
        "created_by.name": true,
        "modified_by.name": false,
        entity_id: false,
        entity_type: false,
        modfied_on: false,
      }}
      tableCollapseWidth={"90%"}
    />
  );
};

export default SubjectOverviewNotes;
